function scrollToAnchor(anchorName) {

    if (anchorName) {
        var top = window.pageYOffset || document.documentElement.scrollTop

        //短短的給動畫-好看
        //長長的給動畫-長看想吐
        if (top != null && top > 150) {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        } else {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }
}
export default scrollToAnchor;